import { Box, Grid, Paper, Step, StepLabel, Stepper } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { CounterSalesContext } from '../../../providers/CounterSalesProvider/CounterSalesProvider'
import { useUpdateCounterSaleMutation } from '../../../redux/api'
import { CounterSaleInfoStatusEnum } from '../../../sdk'
import CounterSaleCart from '.././CounterSaleCart/CounterSaleCart'
import CounterSalePayment from '.././CounterSalePayment/CounterSalePayment'
import CounterSaleConfirmation from '../CounterSaleConfirmation/CounterSaleConfirmation'
import CounterSaleStore from '../CounterSaleStore/CounterSaleStore'

const steps = ['Store', 'Payment', 'Receipt']

const CounterSaleStepper = () => {
  const { activeCounterSale, polling, setPolling } =
    useContext(CounterSalesContext)
  const { accessToken } = useAccessTokenAndShopId()
  const [activeStep, setActiveStep] = useState(0)
  const [openFinixDialog, setOpenFinixDialog] = useState(false)
  const [updateCounterSale, { isLoading }] = useUpdateCounterSaleMutation()

  useEffect(() => {
    if (activeStep === 1 && !openFinixDialog) {
      if (polling === false) {
        setPolling(true)
      }
    } else {
      if (polling === true) {
        setPolling(false)
      }
    }
  }, [activeStep, polling, setPolling, openFinixDialog])

  const handleReset = useCallback(() => {
    setActiveStep(0)
  }, [])

  const handleBack = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }, [])

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }, [])

  const handleFinish = useCallback(async () => {
    await updateCounterSale({
      authorization: accessToken,
      counterSaleEntry: {
        ...activeCounterSale?.entry,
        info: {
          ...activeCounterSale?.entry?.info,
          status: CounterSaleInfoStatusEnum.Completed,
          soldOn: new Date()
        }
      }
    })
    handleReset()
  }, [accessToken, activeCounterSale?.entry, handleReset, updateCounterSale])

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Grid container spacing={2} data-testid="CounterSalesContent">
          <Grid item xs={12} md={8}>
            <Paper variant="outlined">
              <Box padding={2}>
                <Stepper activeStep={activeStep}>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                {activeStep === 0 && <CounterSaleStore />}
                {activeStep === 1 && (
                  <CounterSalePayment
                    handleBack={handleBack}
                    handleNext={handleNext}
                    openFinixDialog={openFinixDialog}
                    setOpenFinixDialog={setOpenFinixDialog}
                  />
                )}
                {activeStep === 2 && (
                  <CounterSaleConfirmation
                    handleBack={handleBack}
                    handleFinish={handleFinish}
                    isLoading={isLoading}
                  />
                )}
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper variant="outlined">
              <Box padding={2}>
                <CounterSaleCart
                  counterSale={activeCounterSale}
                  handleNext={handleNext}
                  handleFinish={handleFinish}
                  showCheckout={activeStep === 0}
                  showReceipt={activeStep === 2}
                  showCustomer={activeStep === 0 || activeStep === 1}
                  readOnly={false}
                />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default CounterSaleStepper
